// This list should mirror the topics in https://git.hubteam.com/HubSpot/transcript-be/blob/master/transcript-be-core/src/main/java/com/hubspot/transcript/be/core/modelintegration/calltopic/CallTopicLabel.java
export const AGENDA = 'AGENDA';
export const ASKING_FOR_INFO = 'ASKING_FOR_INFO';
export const AUTHORITY = 'AUTHORITY';
export const BUDGET = 'BUDGET';
export const INTRODUCTION = 'INTRODUCTION';
export const NEXT_STEPS = 'NEXT_STEPS';
export const NONE = 'NONE';
export const OBJECTION = 'OBJECTION';
export const PAUSE_FOR_QUESTIONS = 'PAUSE_FOR_QUESTIONS';
export const PRICING = 'PRICING';
export const SMALL_TALK = 'SMALL_TALK';
export const TIMING = 'TIMING';
export const callTopics = {
  [AGENDA]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.agenda'
  },
  [ASKING_FOR_INFO]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.askingForInfo'
  },
  [AUTHORITY]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.authority'
  },
  [BUDGET]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.budget'
  },
  [INTRODUCTION]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.introduction'
  },
  [NEXT_STEPS]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.nextSteps'
  },
  [NONE]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.none'
  },
  [OBJECTION]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.objection'
  },
  [PAUSE_FOR_QUESTIONS]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.pauseForQuestions'
  },
  [PRICING]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.pricing'
  },
  [SMALL_TALK]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.smallTalk'
  },
  [TIMING]: {
    translationKey: 'recordingReviewComponents.callTopics.topics.timing'
  },
  UNKNOWN: {
    translationKey: 'recordingReviewComponents.callTopics.topics.unknown'
  }
};